import { MpDataGrid } from './DataGrid'
export default MpDataGrid

export { MpDataGrid } from './DataGrid'
